export const collegeJobs = [
  {
    id: 1,
    title: "Teaching Assistant",
    organization: "Mathematics Dept",
    startDate: "2021-01-02",
    endDate: "2023-06-01",
    logo: "/images/Education/k-logo-rounded.webp",
    bullets: [
      "Helped students by explaining in-class topics and concepts",
      "Collated weekly reports of areas for the professor to review"
    ]
  },
  {
    id: 5,
    title: "Assignment Grader",
    organization: "Mathematics Dept",
    startDate: "2021-09-01",
    endDate: "2022-06-01",
    logo: "/images/Education/k-logo-rounded.webp",
    bullets: [
      "Graded homework assignments and exams for undergraduate mathematics courses :\n(Calculus I, Calculus II, Discrete Math).",
      "Provided feedback to students to support their learning and understanding of course material."
    ]
  },
  {
    id: 2,
    title: "Peer Advisor",
    organization: "Center for International Programs",
    startDate: "2021-09-01",
    endDate: "2023-06-01",
    logo: "/images/Education/k-logo-rounded.webp",
    bullets: [
      "Designed graphics and publications about study abroad in Photoshop and Canva",
      "Collaborated with a group of Peer Advisors to guide students through the study abroad application process",
      "Acted as a liaison between students and study abroad department to address concerns and provide support"
    ]
  },
  {
    id: 3,
    title: "Tour Guide",
    organization: "Admissions Office",
    startDate: "2022-08-01",
    endDate: "2023-03-01",
    logo: "/images/Education/k-logo-rounded.webp",
    bullets: [
      "Led groups of campus visitors on educational and informative tours of the school campus",
      "Answered questions, shared local recommendations, and resolved visitor concerns"
    ]
  },
  {
    id: 4,
    title: "Custodial Assistant",
    organization: "Facilities Management",
    startDate: "2022-06-01",
    endDate: "2022-09-01",
    logo: "/images/Education/k-logo-rounded.webp",
    bullets: [
      "Assisted custodial staff in performing daily cleaning duties, including sweeping, mopping, and vacuuming of dorms and classroom facilities"
    ]
  },
  {
    id: 7,
    title: "Software Engineer",
    organization: "Develop for Good",
    startDate: "2022-06-01",
    endDate: "2023-06-01",
    logo: "/images/Education/develop_for_good_logo.webp",
    bullets: [
      "Collaborated with non-profit organizations to develop web applications",
      "Designed UI/UX for web applications",
      "Participated in code reviews and contributed to team documentation"
    ]
  },
  {
    id: 6,
    title: "Math & German Tutor",
    organization: "Communities in Schools Michigan",
    startDate: "2023-02-01",
    endDate: "2023-07-01",
    logo: "/images/Education/communities_in_schools_of_michigan_inc_logo.webp",
    bullets: [
      "Provided one-on-one tutoring in Mathematics and German to middle school students",
      "Developed Games and Activities to help students learn and practice math",
    ]
  }
];